import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import * as Sentry from "@sentry/react";
import { crmxV2KitEnabled } from "./lib/feature-flags";

// Initialize Sentry BEFORE React mount
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
  release: `crm-x@${import.meta.env.VITE_APP_VERSION}`,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,  // Privacy: mask sensitive data
      blockAllMedia: true,
    }),
  ],

  // Performance monitoring
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,  // 10% in prod, 100% in dev

  // Session replay
  replaysSessionSampleRate: 0.1,  // 10% of sessions
  replaysOnErrorSampleRate: 1.0,  // 100% of sessions with errors

  // Filter out noisy errors
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",  // Common React noise
    "Non-Error promise rejection",
  ],

  // Don't send errors in development
  enabled: import.meta.env.PROD,
});

async function bootstrap() {
  if (crmxV2KitEnabled) {
    await Promise.all([
      import("../../design/tokens.css"),
      import("./styles/crmx-v2.css"),
    ]);
  }

  createRoot(document.getElementById("root")!).render(<App />);
}

void bootstrap();
